module.exports = __webpack_public_path__ + "assets/4-sdr-job-details.80e06f1b.png";